/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconTrash12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTrash12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="m5.26 4.5.24 4.875-.75-.125-.49-4.685 1-.065ZM6.5 9.375 6.74 4.5l1 .065-.49 4.685-.75.125Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.546 1h.908c.216 0 .431 0 .627.065.258.086.48.254.634.478.117.17.175.377.234.585l.015.05.12.424c1.44.153 2.416.472 2.416.898v1l-.745.5-.708 4.92c-.031.22-.072.447-.226.607-.286.296-1.011.723-2.821.723-1.8 0-2.527-.422-2.816-.718-.158-.162-.2-.395-.232-.62L2.255 5 1.5 4.5v-.97c0-.464.976-.782 2.416-.932l.12-.42.014-.05c.06-.208.118-.415.235-.585a1.25 1.25 0 0 1 .634-.478C5.115.999 5.33 1 5.546 1Zm1.456 1.453.02.07a22.455 22.455 0 0 0-2.044-.001l.02-.069c.084-.295.1-.327.111-.344a.25.25 0 0 1 .127-.096c.02-.007.055-.013.362-.013h.803c.307 0 .343.006.362.013a.25.25 0 0 1 .127.096c.012.017.028.05.112.344ZM8.825 4.42l.675-.453v-.075a4.073 4.073 0 0 0-.522-.143C8.258 3.595 7.21 3.5 6 3.5c-1.214 0-2.261.09-2.978.244a3.75 3.75 0 0 0-.522.145v.074l.685.454.774 5.464c.487.333 1.476.369 2.041.369 1.352 0 1.88-.26 2.041-.369l.784-5.461Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconTrash16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTrash16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="m7.013 6 .32 6.5-1-.167-.653-6.246L7.013 6ZM8.667 12.5l.32-6.5 1.333.087-.653 6.246-1 .167Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.394 1.333h1.211c.288 0 .575 0 .836.087.344.115.64.338.845.637.156.227.235.504.313.78l.02.068.16.564C12.7 3.674 14 4.1 14 4.667V6l-.993.667-.944 6.56c-.042.293-.096.596-.302.81-.38.394-1.348.963-3.761.963-2.399 0-3.37-.563-3.754-.957-.212-.216-.267-.526-.31-.826l-.93-6.55L2 6V4.707c0-.62 1.301-1.044 3.222-1.243l.16-.56.018-.067c.079-.276.157-.553.313-.78.205-.299.502-.522.845-.637.262-.088.549-.087.836-.087Zm1.942 1.938.027.093a31.383 31.383 0 0 0-2.725-.002l.025-.09c.113-.394.134-.438.15-.46.04-.06.1-.105.169-.128.026-.009.073-.017.483-.017h1.07c.41 0 .457.008.483.017a.333.333 0 0 1 .169.127c.016.023.037.067.15.46Zm2.431 2.622.9-.604v-.1A5.432 5.432 0 0 0 11.97 5c-.96-.205-2.359-.332-3.971-.332-1.618 0-3.015.12-3.97.324a5 5 0 0 0-.697.195v.098l.914.605 1.032 7.286c.65.443 1.967.492 2.721.492 1.803 0 2.508-.346 2.722-.492l1.045-7.282Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconTrash24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTrash24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m10.52 9 .48 9.75-1.5-.25-.98-9.37 2-.13ZM13 18.75 13.48 9l2 .13-.98 9.37-1.5.25Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.091 2h1.817c.431 0 .862-.002 1.254.13a2.5 2.5 0 0 1 1.268.956c.233.34.35.755.469 1.17l.028.101.242.847C19.05 5.51 21 6.148 21 7v2l-1.49 1-1.415 9.84c-.063.44-.145.895-.453 1.214C17.07 21.646 15.62 22.5 12 22.5c-3.599 0-5.054-.844-5.632-1.435-.317-.325-.4-.79-.464-1.24L4.51 10 3 9V7.06c0-.929 1.952-1.565 4.832-1.864l.24-.839.029-.101c.117-.415.235-.83.469-1.17a2.5 2.5 0 0 1 1.267-.956c.392-.132.823-.13 1.254-.13Zm2.913 2.907.04.139a47.09 47.09 0 0 0-4.088-.002l.039-.137c.169-.59.2-.655.224-.69a.5.5 0 0 1 .253-.19c.04-.014.11-.027.725-.027h1.605c.614 0 .685.013.725.026a.5.5 0 0 1 .253.191c.024.035.056.1.224.69Zm3.647 3.933L19 7.934v-.15a8.147 8.147 0 0 0-1.043-.285C16.517 7.19 14.418 7 12 7c-2.428 0-4.522.18-5.955.487-.464.1-.806.202-1.045.292v.147l1.37.907 1.548 10.93c.975.664 2.951.737 4.082.737 2.704 0 3.762-.519 4.083-.738L17.65 8.84Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconTrash = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTrash(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconTrash12 {...iconProps} />;
        case '16':
            return <IconTrash16 {...iconProps} />;
        case '24':
            return <IconTrash24 {...iconProps} />;
        default:
            return <IconTrash24 {...iconProps} />;
    }
});
